import type { CreateLayoutHighlightStore } from "./types";

export const createLayoutHighlightStore: CreateLayoutHighlightStore = () => {
  let shapeId: string | null = null;
  const listeners = new Set<() => void>();

  return {
    get: () => shapeId,
    set: (nextShapeId) => {
      if (nextShapeId === shapeId) return;
      shapeId = nextShapeId;
      listeners.forEach((listener) => listener());
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
};

// One store for the page: the lists write to it, the layout layer reads it.
export const layoutHighlightStore = createLayoutHighlightStore();
